import { apiClient } from '../../../shared/api/axios-instance'
import type { AxiosResponse } from 'axios'


// Type definition matching backend response structure
export interface BackendTrial {
    id: string
    merchant_id: string
    status: 'active' | 'expired' | 'revoked'
    trial_start_at: string
    trial_end_at: string
    trial_duration_days: number
    trial_bidding_radius_km: number
    trial_visibility_radius_km: number
    days_remaining?: number
    metadata?: any
    merchant?: {
        merchant_id: string
        business_name: string
        email: string
        mobile: string
        status: string
    }
}

export interface TrialsResponse {
    data: BackendTrial[]
    current_page: number
    last_page: number
    total: number
}

export interface AssignTrialRequest {
    merchant_id: string
    duration_days: number
    notes?: string
    trial_bidding_radius_km?: number
    trial_visibility_radius_km?: number
}

export interface RevokeTrialRequest {
    reason: string
}

export const trialsService = {
    /**
     * Get paginated list of trials
     */
    getTrials: async (page = 1, perPage = 15, status?: string): Promise<TrialsResponse> => {
        const params: any = { page, per_page: perPage }
        if (status && status !== 'all') {
            params.status = status
        }
        
        const response: AxiosResponse<TrialsResponse> = await apiClient.get('/admin/trials', { params })
        return response.data
    },

    /**
     * Assign trial to a merchant
     */
    assignTrial: async (data: AssignTrialRequest): Promise<BackendTrial> => {
        const response = await apiClient.post('/admin/trials/assign', data)
        return response.data.trial
    },

    /**
     * Revoke a trial
     */
    revokeTrial: async (merchantId: string, reason: string): Promise<void> => {
        await apiClient.post(`/admin/trials/${merchantId}/revoke`, { reason })
    },

    /**
     * Extend a trial
     */
    extendTrial: async (merchantId: string, durationDays: number): Promise<void> => {
        await apiClient.post(`/admin/trials/${merchantId}/extend`, { duration_days: durationDays })
    }
}
